// Module
var code = "<div class=\"c-welcome\">\n    <video controls class=\"c-welcome-video\" src=\"http://cdn.contentdirect.tv/Client/CustomerCare/ITVDelta_Beta.mp4\" autoplay></video>\n</div>\n";
// Exports
module.exports = code;